export let senderEmailNotFoundLabel = "irbcQd";
export default {senderEmailNotFoundLabel};